import { render } from "./SvgButton.vue?vue&type=template&id=1cdbc4a5&scoped=true"
import script from "./SvgButton.vue?vue&type=script&lang=js"
export * from "./SvgButton.vue?vue&type=script&lang=js"

import "./SvgButton.vue?vue&type=style&index=0&id=1cdbc4a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdbc4a5"]])

export default __exports__